/* TOP スペシャルバナー*/
$('.special-close-btn').on('click',function(){
$('.special-wrap').addClass('close');
  
  return false;
});


/* 商品詳細 数量　*/  
$('.quantity-wrapper .btnqty').on('click', function(){
          var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
          if($(this).hasClass('qtyplus')) {
            qty++; 
          }else {
            if(qty > 1) {     
              qty--;
            } 
          } 
          qty = (isNaN(qty))?1:qty;
          $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 


//外部ページ アンカーリンク
var headerHeight = $('.site-header').outerHeight();
var urlHash = location.hash;
if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
        var target = $(urlHash);
        var position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, 500);
    }, 100);
}
$('.info-menu a[href^="#"],.footer-navigation a[href^="#"],.productsdetail-notes a[href^="#"]').click(function() {
    var href= $(this).attr("href");
    var target = $(href);
    var position = target.offset().top - headerHeight + 60;
    $('body,html').stop().animate({scrollTop:position}, 500);   
});

  
  　
  
$(window).on('load',function(){
  
  /*お気に入り ページ*/
  if($('.swym-hosted-page').length){

    $('#swym-plugin-name').html('');
  	$('.swym-hosted-page #swym-plugin-name').before('<nav id="breadcrumb"><ul><li><a href="https://friendlyhealthclub.jp">TOP</a></li><li><span>お気に入りリスト</span></li></ul></nav>');
  	$('.swym-hosted-page #swym-plugin-name').prepend('<span class="jp">お気に入りリスト</span>');
    
  }
  if($('#customers-register-ara-edit').length){
  $('#site-customers-account .customers-select-disabled select').attr('disabled', 'disabled');
   }
  
  //商品詳細ページ tax追加
  if($('.price__regular').length){
  $('.price__regular dd').append('<span class="tax">(税込)</span>');
  }
  //商品詳細ページ tax追加 定期購入
    if($('.bold-ro__recurring-text').length){
  $('.bold-ro__recurring-text').append('<span class="tax">(税込)</span>');
  }
  
  //定期購入ページ
   if($('#manage-subscription-root').length){
     
      $('.manage-subscription-page').prepend('<h2 class="manage-subscription-page-title">定期購入の管理</h2>');
      $('#manage-subscription-root').wrap('<div id="customers-common" class="site-manage-subscription">');
      $('#manage-subscription-root').before('<nav id="breadcrumb"><ul><li><a href="https://friendlyhealthclub.jp">TOP</a></li><li><span>定期購入</span></li></ul></nav>');
      $('.manage-subscription-page').after('<div class="myaccount-page-back"><a href="/account" class="btn">戻る</a></div>');
      $('body').addClass('body-manage-subscription');
   	
     
  }
   
 }); 


//商品詳細 レビューアンカーリンク
if($('.spr-badge-caption').length){
  $('a[href^="#"]').click(function() {
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
   });
	
  }


//ShopList アコーディオン プラスマイナス
if($('#acd-check1').length) {
  var toggles1 = $('div#site-pages-shoplist section.shoplist div label.one');
  toggles1.click( function (event) {
    toggles1.toggleClass("on");
  });
}
if($('#acd-check2').length) {
  var toggles2 = $('div#site-pages-shoplist section.shoplist div label.two');
  toggles2.click( function (event) {
    toggles2.toggleClass("on");
  });
}
if($('#acd-check3').length) {
  var toggles3 = $('div#site-pages-shoplist section.shoplist div label.three');
  toggles3.click( function (event) {
    toggles3.toggleClass("on");
  });
}
if($('#acd-check4').length) {
  var toggles4 = $('div#site-pages-shoplist section.shoplist div label.four');
  toggles4.click( function (event) {
    toggles4.toggleClass("on");
  });
}